import type { OptionProps } from '@ps-smart-cp/ppfw-client';
import type { ReactNode } from 'react';
import { createContext, useContext, useEffect, useState } from 'react';
import type { Book } from '../models';
import { fetchBooks } from '../repositories';

interface UsedBook {
  key: number;
  bookName: string;
}

interface BookContextProps {
  books: Book[];
  usedBooks: UsedBook[];
  updateBooks: () => Promise<void>;
  bookOptions: OptionProps[];
}

const BookContext = createContext<BookContextProps>({
  books: [],
  usedBooks: [],
  updateBooks: async () => {},
  bookOptions: [],
});

function BooksProvider({ children }: { children: ReactNode }) {
  const [books, setBooks] = useState<Book[]>([]);
  const [isDateFetchingEnd, setIsDateFetchingEnd] = useState(false);
  const updateBooks = async () => setBooks(await fetchBooks());

  useEffect(() => {
    const fetchData = async () => {
      setBooks(await fetchBooks());
      setIsDateFetchingEnd(true);
    };

    void fetchData();
  }, []);

  return (
    <BookContext.Provider
      value={{
        books,
        usedBooks: books.filter(({ isUsed }) => isUsed),
        updateBooks,
        bookOptions: books
          .filter(({ isUsed }) => isUsed)
          .map((val) => {
            return {
              optionValue: val.key.toString(),
              displayValue: val.key.toString() + ' ' + val.bookName,
            };
          }),
      }}
    >
      {isDateFetchingEnd ? children : null}
    </BookContext.Provider>
  );
}

function useBooks() {
  return useContext(BookContext);
}

export { BooksProvider, useBooks };
export type { UsedBook };
